import { useState } from "react";
import {
  Clock,
  Dog,
  Droplets,
  MapPin,
  Moon,
  Phone,
  Recycle,
  Sparkles,
  Wifi,
  type LucideIcon,
} from "lucide-react";
import type { GuestTabletGuideSection } from "@/types/guestTablet";

const ICONS: Record<string, LucideIcon> = {
  wifi: Wifi,
  moon: Moon,
  recycle: Recycle,
  droplets: Droplets,
  clock: Clock,
  phone: Phone,
  dog: Dog,
  "map-pin": MapPin,
  sparkles: Sparkles,
};

type Props = {
  sections: GuestTabletGuideSection[];
  /** Im Check-in-Wizard: begrenzte Höhe, intern scrollbar */
  wizardMode?: boolean;
};

export function TabletGuestGuide({ sections, wizardMode = false }: Props) {
  const [openId, setOpenId] = useState<string | null>(sections[0]?.id ?? null);

  return (
    <section
      className={`guest-tablet-card flex flex-col p-6 md:p-8 ${
        wizardMode ? "h-full min-h-0 overflow-hidden" : ""
      }`}
    >
      <h2 className="guest-tablet-section-title mb-4 shrink-0">Digitale Gästemappe</h2>
      <div
        className={`grid gap-3 md:grid-cols-2 ${
          wizardMode ? "min-h-0 flex-1 overflow-y-auto overscroll-contain" : ""
        }`}
      >
        {sections.map((section) => {
          const Icon = ICONS[section.icon] ?? Sparkles;
          const isOpen = openId === section.id;
          return (
            <button
              key={section.id}
              type="button"
              onClick={() => setOpenId(isOpen ? null : section.id)}
              className={`guest-tablet-touch-btn w-full text-left transition-all ${
                isOpen
                  ? "bg-emerald-800 text-white shadow-md"
                  : "bg-emerald-900/5 hover:bg-emerald-900/10 dark:bg-white/5"
              }`}
            >
              <div className="flex items-center gap-3">
                <Icon className="h-6 w-6 shrink-0 opacity-90" />
                <span className="text-lg font-semibold">{section.title}</span>
              </div>
              {isOpen && (
                <p className="mt-4 whitespace-pre-line text-base font-normal leading-relaxed opacity-95">
                  {section.body}
                </p>
              )}
            </button>
          );
        })}
      </div>
    </section>
  );
}
